import { FC, ReactNode } from "react";

type TMapVehicleListingColumnItemProps = {
  asideText: ReactNode | string;
  bottomText: string;
  description: string;
  title: string;
};

const MapVehicleListingColumnItemForBuzzerAlert: FC<TMapVehicleListingColumnItemProps> = ({
  asideText,
  bottomText,
  description = '',
  title,
}) => {
  return (
    <div
      className={`ps-4 pe-2 pt-3 pb-3 bg-white rounded-lg`}
    >
      <div className="grid grid-cols-12">
        <div className="col-span-8 flex items-start gap-3">
          <div className="break-words xflex xflex-col">
            <p className="font-semibold text-sm leading-4 mb-1 text-accent-blue-dark">
              {title}
            </p>
            {!!description && (<p className="font-normal text-[10px] leading-4 text-gray-500 mt-[2px]">
              {description}
            </p>)}
            <p className="font-medium text-xs leading-4 text-gray-700 mt-1">
              {bottomText}
            </p>
          </div>
        </div>
        <div className="col-span-4 font-bold text-xs leading-4 text-right">
          {asideText}
        </div>
      </div>
    </div>
  );
}
export default MapVehicleListingColumnItemForBuzzerAlert;